import { $enum } from 'ts-enum-util'

export enum DAT_EQUIPMENT_TYPES {
  VAN = 'Van',
  VAN_VENT = 'Van, Vented',
  VAN_W_TEAM = 'Van w/Team',
  REEFER = 'Reefer',
  REEFER_W_TEAM = 'Reefer w/Team',
  VAN_OR_REEFER = 'Van or Reefer',
  FLATBED = 'Flatbed',
  FLATBED_W_TEAM = 'Flatbed w/Team',
  DOUBLE_DROP = 'Double Drop',
  STEP_DECK = 'Step Deck',
}

export const datEquipmentTypes = $enum(DAT_EQUIPMENT_TYPES).map(value => ({ label: value, value }))

export enum DAT_FLAGS {
  marketOnMarketplace = 'market_on_marketplace',
  marketOnLoadBoards = 'market_on_load_boards',
}
